var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAudioExo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 125,
    height: 126,
    viewBox: "0 0 125 126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PASTILLE",
    transform: "translate(-0.184 0.492)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SON",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 62.5,
    cy: 63,
    rx: 62.5,
    ry: 63,
    transform: "translate(0.184 -0.493)",
    fill: "#51aabc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "music-and-multimedia_1_",
    "data-name": "music-and-multimedia (1)",
    transform: "translate(28.022 30.325)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    d: "M41.039,16.224a2.347,2.347,0,0,0-2.49.282l-22.9,18.318H4.708A4.716,4.716,0,0,0,0,39.532V58.364a4.713,4.713,0,0,0,4.708,4.708H15.649L38.543,81.39a2.357,2.357,0,0,0,2.5.278,2.349,2.349,0,0,0,1.332-2.119v-61.2A2.361,2.361,0,0,0,41.039,16.224Z",
    transform: "translate(0 -15.99)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    d: "M345.759,122.93a2.355,2.355,0,1,0-3.31,3.352,18.777,18.777,0,0,1,0,26.59,2.352,2.352,0,1,0,3.31,3.343,23.482,23.482,0,0,0,0-33.285Z",
    transform: "translate(-291.473 -106.619)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1344",
    "data-name": "Path 1344",
    d: "M390.881,77.808a2.355,2.355,0,1,0-3.319,3.343,28.092,28.092,0,0,1,0,39.871,2.355,2.355,0,0,0,3.319,3.343,32.808,32.808,0,0,0,0-46.556Z",
    transform: "translate(-329.952 -68.131)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAudioExo);
export default __webpack_public_path__ + "static/media/icon_audio_exo.3037e533.svg";
export { ForwardRef as ReactComponent };